import React, { useState } from "react";
import { filter } from "ramda";
import { Box } from "@thecb/components";

import SearchBar from "@/components/search-bar";
import CustomersTable from "./CustomersTable";
import CriteriaForm from "./CriteriaForm";

import Pill from "@/components/generic/Pill";
import { noop } from "@/util/common";

import { SearchPageContainer, SearchPageContent } from "./CustomerSearchPage.styled";

const descriptionFromKey = (key) =>
  key
    .split(/(?=[A-Z])/)
    .join(" ")
    .split("")
    .map((letter, index) =>
      index === 0 ? letter.toUpperCase() : letter.toLowerCase()
    )
    .join("");

const createCustomerParameterPills = (criteria, actions, setSearchBarOpen) => {
  const filteredCriteria = filter((value) => value.rawValue !== "", criteria);
  return [
    ...Object.keys(filteredCriteria).map((key) => (
      <Box padding="4px" key={key} maxWidth="fit-content">
        <Pill
          onClickBody={setSearchBarOpen}
          valueDescription={descriptionFromKey(key)}
          value={filteredCriteria[key].rawValue}
          onDelete={() => actions.fields[key].set("")}
          onBlur={noop}
          onChange={(e) => actions.fields[key].set(e.target.value)}
          editable
          isError={filteredCriteria[key].dirty && filteredCriteria[key].hasErrors}
        />
      </Box>
    )),
  ];
};

const CustomerSearchPage = ({
  actions,
  forms,
  customers,
  searchResultsPageCount,
  requestSearch,
  searchRequested,
  setSearchRequested,
  searchRequestPending,
  searchRequestError,
  userTimezone,
  pagePrevious,
  pageNext,
  setCurrentPage,
  currentPage,
  showCustomerPendingError,
  setCustomerPendingError,
  removeCustomerPendingError,
  clientMeta,
}) => {
  const [searchBarOpen, setSearchBarOpen] = useState(false);

  const criteriaForm = forms.criteriaForm.fields;
  const criteriaActions = actions.forms.criteriaForm.actions;

  const pills = createCustomerParameterPills(
    criteriaForm,
    criteriaActions,
    setSearchBarOpen
  );

  const submitSearch = () => {
    // validate that at least one criteria has been selected and filled out correctly
    const validCriteria = Object.keys(criteriaForm).some(
      (field) =>
        criteriaForm[field].rawValue !== "" && !criteriaForm[field].hasErrors
    );

    if (validCriteria) {
      setSearchRequested(true);
      requestSearch();
    }
  };
  return (
    <SearchPageContainer>
      <SearchPageContent $align="center">
        <SearchBar
          isOpen={searchBarOpen}
          onClick={searchBarOpen ? noop : () => setSearchBarOpen(true)}
          onClickAway={() => {
            setSearchBarOpen(false);
          }}
          onSearch={searchBarOpen ? () => setSearchBarOpen(false) : noop}
          searchAction={submitSearch}
          defaultText="Search customers"
          bodyOpenText="Build your search below"
          searchBarContent={pills}
          clearSearchBarContent={(evt) => {
            evt.stopPropagation();
            criteriaActions.form.clear();
          }}
          searchRequestPending={searchRequestPending}
        >
          <CriteriaForm
            actions={criteriaActions}
            fields={criteriaForm}
            descriptionFromKey={descriptionFromKey}
          />
        </SearchBar>
        <CustomersTable
          customers={customers}
          userTimezone={userTimezone}
          searchRequested={searchRequested}
          waitingForSearch={searchRequestPending}
          searchFailed={searchRequestError}
          searchResultsPageCount={searchResultsPageCount}
          pagePrevious={pagePrevious}
          pageNext={pageNext}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          showCustomerPendingError={showCustomerPendingError}
          setCustomerPendingError={setCustomerPendingError}
          removeCustomerPendingError={removeCustomerPendingError}
          navigateURL={clientMeta?.value?.paymentPortalUrl?.value}
        />
      </SearchPageContent>
    </SearchPageContainer>
  );
};

export default CustomerSearchPage;
